export function isRTL(scope) {
    if (typeof window === 'undefined')
        return false;
    if (!scope)
        scope = document.documentElement;
    return window.getComputedStyle(scope).direction === 'rtl';
}
